import {
	CadFile,
	CalibrationCertificate,
	ComplianceCertificate,
	SafetyInstructions,
	UserManual,
} from '@/lib/digital-twin'
import {
	DocumentText,
	MedalStar,
	cn,
	Download,
	Tooltip,
	TooltipProvider,
	TooltipContent,
	TooltipTrigger,
	Button,
} from '@desoutter/uikit'
import Image from 'next/image'
import Share from '@/components/ProductResources/Share'
import { LanguageRecord } from '@/graphql/types'

export enum ResourceType {
	Document = 'document',
	Certificate = 'certificate',
	Technical = 'technical',
}

type ProductResourcesCardProps = {
	title: string
	description?: string
	// documentType: string
	// version?: string
	documentSize: number
	column1?: string
	column2?: string
	column3?: string
	column4?: string
	resourceType: ResourceType
	document:
		| SafetyInstructions
		| UserManual
		| CalibrationCertificate
		| ComplianceCertificate
		| CadFile
	translations: LanguageRecord
}

export default function ProductResourcesCard({
	title,
	resourceType,
	description,
	documentSize,
	column1,
	column2,
	column3,
	column4,
	document,
	translations,
}: ProductResourcesCardProps) {
	const isLanguageMulti =
		document['item_language'] === 'Multi' || !document['item_language']

	const formattedDocumentSize = Math.ceil(documentSize / (1024 * 1024))

	const cardHeight =
		resourceType === ResourceType.Technical ? 'max-h-80' : 'min-h-52 max-h-60'

	return (
		<div
			className={cn(
				'flex flex-col justify-between w-full py-4 gap-2 h-full border-b-2 border-gray-100 last:border-b-0',
				// cardHeight,
			)}
		>
			<div className="flex gap-5 w-full">
				<div className="flex-1 flex justify-center flex-col gap-0.5">
					<p className="font-normal text-sm text-clamp-2 break-words">
						{title}
					</p>
					<p className="text-gray-400 text-xs text-clamp-1">{description}</p>
				</div>

				<div className="w-8 flex justify-center items-center">
					{resourceType == ResourceType.Document && (
						<Image
							src={`/images/flags/${isLanguageMulti ? 'multi' : document['item_language']}.png`}
							alt={document['item_language']}
							width={20}
							height={15}
							className={cn(
								'border border-gray-200',
								isLanguageMulti && 'border-none',
							)}
						/>
					)}
				</div>
				<div className="flex items-center gap-5 text-sm">
					{column1 && (
						<div className="w-16 text-center whitespace-nowrap text-wrap">
							{column1}
						</div>
					)}
					{column2 && (
						<div className="w-16 text-center whitespace-nowrap text-wrap">
							{column2}
						</div>
					)}
					{column3 && (
						<div className="w-16 text-center whitespace-nowrap text-wrap">
							{column3}
						</div>
					)}
					{column4 && (
						<div className="w-16 text-center whitespace-nowrap text-wrap">
							{column4}
						</div>
					)}
					<div className="w-12 text-center whitespace-nowrap">
						{`${formattedDocumentSize} MB`}
					</div>
				</div>
				<div className="w-10 flex items-center justify-end gap-2 ms-8">
					<TooltipProvider delayDuration={50}>
						<Tooltip>
							<TooltipTrigger asChild>
								<a
									href={document.item_path}
									target="_blank"
									aria-label={translations.download}
								>
									<Button
										className="border border-gray-200 w-8"
										size="sm"
										color="tertiary"
										variant="outline"
										icon={Download}
										iconBefore
									/>
								</a>
							</TooltipTrigger>
							<TooltipContent side="bottom">
								{translations.download || 'Download'}
							</TooltipContent>
						</Tooltip>
					</TooltipProvider>
					{/* <Share
						className="border border-gray-200 w-8"
						shareURL={document.item_path}
						btnSize="sm"
						aria-label={translations.shareToAFriend}
						title={translations.shareToAFriend}
					/> */}
				</div>
			</div>
		</div>
	)
}
